module.exports = __webpack_public_path__ + "img/standardFighter.fc425bdc.png";